export enum navThemeValues {
    WHITE = "white",
    BLACK = "black",
    WHITE_TRANS = "white_trans",
    BLACK_TRANS = "black_trans",
}
